import { SpaceXxs, SpaceMd } from "@nxt-costco-com/forge-design-tokens";
const cardBodyContainerStyles = {
  display: "flex",
  flexDirection: "column",
  gap: SpaceXxs,
  position: "relative"
};
const imageStyles = {
  marginBottom: SpaceMd
};
const childElementStyles = {
  zIndex: 2
};
export {
  cardBodyContainerStyles,
  childElementStyles,
  imageStyles
};
